<template>
  <div class="preference-checkboxes">
    <div class="checkbox-standard" v-for="preference in preferences" :key="preference.id">
      <label class="custom-checkbox">
        <input type="checkbox" id="block" v-model="userPreferences" @change="change($event, preference)" name="block" :value="preference.id" />
        <span class="custom-checkbox__label">
          <span class="custom-checkbox__circle"></span>
          {{ preference.name }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import PreferencesChooseMixin from './PreferencesChooseMixin';

export default {
  name: 'PreferencesChooseComponent',
  components: {},
  mixins: [PreferencesChooseMixin],
  props: {
    value: { type: Array },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    value(val) {
      this.userPreferences = val;
    },
    userPreferences(val) {
      this.$emit('input', val);
    },
  },
  methods: {},
  mounted() {
    this.userPreferences = this.value;
  },
};
</script>

